const TYPE_LIST = [
    'main',
    'inbound',
    'outbound',
    'invoice',
];
export const TYPES = TYPE_LIST.map(key => ({
    key,
    label: `resource.address.properties.type.options.${key}`,
}));
